<template>
    <div class="content-body customers-wrapper transaction-history">
        <b-row class="mb-4">
            <b-col class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <span class="feedbacks-tooltip">
                    Overview
                    <b-btn class="pl-0" variant="ghost" v-b-popover.hover="'Set a list of topics your loyalty member can choose when sending a feedback through their app'" title="">
                        <i class="ic-tooltip" id="topics"></i>
                    </b-btn>
                </span>
            </b-col>
            <b-col sm="3" md="2" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
              <div class="filter-wrapper">
                <b-form-select v-model="selectedBranch" :options="branchFilter" @input="filterBranch()" />
              </div>
            </b-col>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <b-input-group>
                    <b-input-group slot="append">
                        <i class="icon-calendar"></i>
                    </b-input-group>
                    <datepicker
                        :config="dateRangeConfig">
                    </datepicker>
                </b-input-group>
            </b-col>
        </b-row>
        <div class="sales-cards">
            <b-row class="mb-4">
                <b-col>
                    <b-card header-tag="header" footer-tag="footer">
                        <template slot="header">
                            <h6 class="mb-0 d-inline-block">Gender</h6>
                            <i class="ic-tooltip" id="help"></i>
                        </template>
                        <b-table
                            :fields="customerGenderFields"
                            :items="customerGender"
                            show-empty
                            :empty-text="(loading) ? 'Loading data' : emptyText"
                        ></b-table>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col>
                    <b-card header-tag="header" footer-tag="footer">
                        <template slot="header">
                            <h6 class="mb-0 d-inline-block">Demographics</h6>
                            <i class="ic-tooltip" id="help"></i>
                        </template>
                        <b-table
                            :fields="ageGroupRegistrationsFields"
                            :items="ageGroupRegistrations"
                            show-empty
                            :empty-text="(loading) ? 'Loading data' : emptyText"
                        ></b-table>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col>
                    <b-card header-tag="header" footer-tag="footer">
                        <template slot="header">
                            <h6 class="mb-0 d-inline-block">Branch Registrations</h6>
                            <i class="ic-tooltip" id="help"></i>
                        </template>
                        <b-table
                            :fields="branchRegistrationCountFields"
                            :items="branchRegistrationCount"
                            show-empty
                            :empty-text="(loading) ? 'Loading data' : emptyText"
                        ></b-table>
                        <template slot="footer">
                            <b-row no-gutters>
                                <b-col>
                                    <div class="mt-1">
                                        <span class="pagination-indicator">Showing {{ branchRegistrationCountPagination.currentFirstItem }} to {{ branchRegistrationCountPagination.currentLastItem }} of {{ branchRegistrationCountPagination.maxPage}} pages</span>
                                    </div>
                                </b-col>
                                <b-col>
                                    <b-pagination
                                        hide-goto-end-buttons
                                        align="right"
                                        size="md"
                                        :total-rows="(branchRegistrationCountPagination.totalPerPage > 0 ) ? branchRegistrationCountPagination.maxPage * branchRegistrationCountPagination.totalPerPage : 1"
                                        :limit="(branchRegistrationCountPagination.totalPerPage > 0 ) ? 5 : 1"
                                        :per-page="branchRegistrationCountPagination.totalPerPage"
                                        @change="branchRegistrationCountPaginate"
                                        class="custom-pagination">
                                    </b-pagination>
                                </b-col>
                            </b-row>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col>
                    <b-card header-tag="header" footer-tag="footer">
                        <template slot="header">
                            <h6 class="mb-0 d-inline-block">Top Visiting Customers</h6>
                            <i class="ic-tooltip" id="help"></i>
                        </template>
                        <b-table
                            :fields="topVisitingCustomersFields"
                            :items="topCustomerVisit"
                            show-empty
                            :empty-text="(loading) ? 'Loading data' : emptyText"
                        ></b-table>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import Datepicker from "vue-bulma-datepicker";
import { mapState } from "vuex";

const items = [];

export default {
    name: "sales",
    components: {
        Datepicker
    },
    data() {
        return {
            selectedBranch: "",
            branchOptions: [
                { value: "all", text: "All Branches" }
            ],
            items: items,
            emptyText: "No Records Found",
            topVisitingCustomersFields: [
                { key: "membership_id", label: "Card number (Membership ID)" },
                { key: "customer_name", label: "Name" },
                { key: "total_agg_visit", label: "Total Visits (Transaction Count)" }
            ],
            branchRegistrationCountFields: [
                { key: "branch_name", label: "Branch Name" },
                { key: "male", label: "Male Users" },
                { key: "female", label: "Female Users" },
                { key: "total", label: "Total Registered Users" }
            ],
            customerGenderFields: [
                { key: "gender" },
                { key: "registration_count" }
            ],
            ageGroupRegistrationsFields: [
                { key: "age_group_name", label: "Age Group" },
                { key: "registration_count", label: "Registration Count" }
            ]
        }
    },
    computed: {
        ...mapState("analytics", [
            "loading",
            "branchPerformance",
            "branchPerformancePagination",
            "branchFilter",
            "visitTierType",
            "skuPerformance",
            "skuPerformancePagination",
            "topCustomerVisit",
            "branchRegistrationCount",
            "branchRegistrationCountPagination",
            "customerGender",
            "ageGroupRegistrations",
            "page",
            "perPage",
            "maxPage",
            "nextPage",
            "prevPage",
            "message",
            "customer",
            "currentFirstItem",
            "currentLastItem",
            "currentPage",
            "totalPerPage"
        ]),
        ...mapState("auth", ["enabledTopUps"]),
        dateRangeConfig: {
            get: function() {
                let _this = this;
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    // defaultDate: ["today", "today"],
                    onChange: function(selectedDates) {
                        _this.selectedDate(selectedDates);
                        _this.range = selectedDates;
                    },
                    maxDate: "today"
                };
            }
        },
        ...mapState("auth", {
            isLogin: state => state.login,
            user: state => state.user,
            enabledTopUps: state => state.enabledTopUps,
            merchant: state => state.merchant
        })
    },
    created() {
        this.getTopCustomerVisit();
        this.getBranchFilter(this.user.merchant_uuid);
        this.getBranchRegistrationCount(1);
        this.getCustomerGender();
        this.getAgeGroupRegistrations();
    },
    methods: {
        async getTopCustomerVisit() {
            let param = {
                payload: this.searchPayload
            };
            await this.$store.dispatch("analytics/getTopCustomerVisit", param);
        },
        async getBranchRegistrationCount(page) {
            
            let startDate = this.range != null ? this.$moment(this.range[0]).format("YYYY-MM-DD") : null;
            let endDate = this.range != null ? this.$moment(this.range[1]).format("YYYY-MM-DD") : null;
            let branch = this.branchFilter.find( branchFilter => branchFilter.value === this.selectedBranch);

            let param = {
                payload: {
                    start_date: startDate,
                    end_date: endDate,
                    branch_uuid: branch.uuid != undefined ? branch.uuid : null
                },
                page: page
            };

            await this.$store.dispatch("analytics/getBranchRegistrationCount", param);
        },
        branchRegistrationCountPaginate(page) {
        // if (this.searching) {
        //     return this.search(false, page);
        // }
            return this.getBranchRegistrationCount(page);
        },
        async getAgeGroupRegistrations() {
            let param = {
                payload: this.searchPayload
            };
            await this.$store.dispatch("analytics/getAgeGroupRegistrations", param);
        },
        async getCustomerGender() {
            let param = {
                payload: this.searchPayload
            };
            await this.$store.dispatch("analytics/getCustomerGender", param);
        },
        selectedDate(value) {
            let range = {};

            if (value.length == 2) {
                range = this.getRange(value);

                this.filterDate(range, this.currentPage);
            }
        },
        getRange(value) {
            this.range = value;

            let range = {
                start: this.$moment(value[0]).format("YYYY-MM-DD"),
                end: this.$moment(value[1]).format("YYYY-MM-DD")
            };
            return range;
        },
        async filterDate(range, page = 1) {
            let param = {
                payload: {
                    start_date: range.start,
                    end_date: range.end,
                    branch_code: this.selectedBranch == "" ? null : this.selectedBranch
                },
                page: page
            };

            await this.$store.dispatch("analytics/getTopCustomerVisit", param);

            let branch = this.branchFilter.find( branchFilter => branchFilter.value === this.selectedBranch);

            let specialParam = {
                payload: {
                    start_date: range.start,
                    end_date: range.end,
                    branch_uuid: branch.uuid != undefined ? branch.uuid : null
                },
                page: page
            };

            await this.$store.dispatch("analytics/getBranchRegistrationCount", specialParam);
            await this.$store.dispatch("analytics/getCustomerGender", specialParam);
            await this.$store.dispatch("analytics/getAgeGroupRegistrations", specialParam);
        },
        async filterBranch() {

            let startDate = this.range != null ? this.$moment(this.range[0]).format("YYYY-MM-DD") : null;
            let endDate = this.range != null ? this.$moment(this.range[1]).format("YYYY-MM-DD") : null;
            
            let param = {
                payload: {
                    start_date: startDate,
                    end_date: endDate,
                    branch_code: this.selectedBranch == "" ? null : this.selectedBranch
                },

                page: 1
            };

            await this.$store.dispatch("analytics/getTopCustomerVisit", param);

            let branch = this.branchFilter.find( branchFilter => branchFilter.value === this.selectedBranch);
            
            let specialParam = {
                payload: {
                    start_date: startDate,
                    end_date: endDate,
                    branch_uuid: branch.uuid != undefined ? branch.uuid : null
                },
                page: 1
            };

            await this.$store.dispatch("analytics/getBranchRegistrationCount", specialParam);
            await this.$store.dispatch("analytics/getCustomerGender", specialParam);
            await this.$store.dispatch("analytics/getAgeGroupRegistrations", specialParam);
        },
        getBranchFilter(merchantUuid) {
            this.$store.dispatch("analytics/getBranchFilter", merchantUuid);
        },
    }
}
</script>